import { useLocation, useNavigate } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import "datatables.net";
import "datatables.net-responsive";
import { toast } from "react-toastify";
import { getAuthCookie } from "../../utils/authCookies";
// import "react-toastify/dist/ReactToastify.css";

type Country = {
  _id: string;
  name: string;
  code: string;
};

const SignageCountries = () => {
  const [countries, setCountries] = useState<Country[]>([]);
  const [error, setError] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [deleting, setDeleting] = useState<string | null>(null); // Track deletion in progress
  const token = getAuthCookie("sessionToken");

  const [toastShown, setToastShown] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/location/countries`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        setCountries(data);
      } catch (err) {
        setError(
          err instanceof Error ? err.message : "An unknown error occurred"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchCountries();
  }, [token]);

  // if (countries?.length === 0) {
  //   return <div>Loading...</div>;
  // }

  useEffect(() => {
    if(countries!=null && countries?.length > 0) {
      const table = $("#transactions").DataTable({
        responsive: false,
        destroy: true,
        lengthChange: false,
        ordering: false,
      });

      return () => {
        table.destroy();
      };
    }
  }, [countries]);

  const handleDelete = async (countryId: string) => {

    setDeleting(countryId); // Set the license being deleted

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/location/countries/${countryId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to delete the country.");
      }

      toast.success("Country deleted successfully!");
      // Update the state by removing the deleted license
      setCountries((prev) =>
        prev?.filter((country) => country._id !== countryId)
      );
      setDeleting(null); // Clear the deleting state
      navigate(0);
    } catch (err) {
      toast.error("Failed to delete the country.");
      setError(
        err instanceof Error
          ? err.message
          : "An unknown error occurred while deleting."
      );
      setDeleting(null); // Clear the deleting state
    }
  };

//   if (loading) {
//     return <div>Loading...</div>;
//   }

  return (
    <div className="content">
      <div className="card">
        <div className="card-body">
          <h2>Countries </h2>
          <div className="text-end">
            <Link
              to="/signage/addCountry"
              className="btn btn-primary float-right"
            >
              Add Country
            </Link>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-12 col-xl-12">
              <div className="card mt-4 card-bg-fill">
                <div className="card-body p-4">
                  <div className="table-container">
                    <table
                      id="transactions"
                      className="table table-bordered dt-responsive nowrap table-striped align-middle w-100"
                    >
                      <thead>
                        <tr>
                          <th>S.No.</th>                          
                          <th>Name</th>
                          <th>Code</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {countries!= null &&
                          countries?.map((country, index) => (
                            <tr key={index}>                              
                              <td>{index + 1}</td>   
                              <td>
                              <Link
                                  to={`/signage/states/${country._id}`}
                                  >
                                {country.name}
                                </Link>
                                </td>
                              <td>{country.code}</td>
                              <td>
                                <Link
                                  to={`/signage/editCountry/${country._id}`}
                                  className="btn btn-warning waves-effect waves-light me-2"
                                >
                                  <i className="ri-pencil-fill align-bottom me-2"></i>{" "}
                                </Link>

                                <button
                                  onClick={() =>
                                    window.confirm(
                                      "Are you sure you want to delete this country?"
                                    ) && handleDelete(country._id)
                                  }
                                  className="btn btn-danger waves-effect waves-light"
                                >
                                  <i className="ri-delete-bin-fill align-bottom me-2"></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignageCountries;
